const isNumberCode = `import { isNumber } from 'cristatus';

const isNumber = isNumber(10); //true
`;

export default isNumberCode;
